import httpClient from "./httpClient";

export const insertComment = async (payload) => {
  const endpoint = "/refcomments/create";
  return httpClient.post(endpoint, payload);
};

export const updateComment = async (payload) => {
  const endpoint = "/refcomments/update";
  return httpClient.put(endpoint, payload);
}

export const deleteComment = async (payload) => {
  const endpoint = "/refcomments/delete";
  return httpClient.delete(endpoint, { data: payload });
}

export const addLike = async (payload) => {
  const endpoint = "/reflikes/create";
  return httpClient.post(endpoint, payload);
};

export const deleteLike = async (payload) => {
  const endpoint = "/reflikes/delete";
  return httpClient.delete(endpoint, { data: { Id: payload } });
};

export const viewLikes = async (payload) => {
  const endpoint = `/refusers/userBasicInfo`;
  return httpClient.post(endpoint, payload);
};

export const deleteBookmark = async (payload) => {
  const endpoint = "/refbookmarks/delete";
  return httpClient.delete(endpoint, {
    data: { id: payload.id, userId: payload.userId },
  });
};

export const addBookmark = async (payload) => {
  const endpoint = "/refbookmarks/create";
  return httpClient.post(endpoint, payload);
};

export const getBookmarks = async (payload) => {
  const endpoint = `refbookmarks/getmany?Limit=${payload.limit}&PageNumber=${
    payload.pageIndex
  }&userId=${payload.userId || ""}`;
  return httpClient.get(endpoint, payload);
};

export default {
  insertComment,
  updateComment,
  addLike,
  deleteLike,
  deleteBookmark,
  addBookmark,
  getBookmarks,
  viewLikes,
  deleteComment
};
